import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { PODDataModel } from "@WhiteCap/Store/Service/PODService";

import { Draft } from "immer";

export interface PODDataState {
    isLoading: boolean;
    PODData: any;
}

const initialState: PODDataState = {
    isLoading: false,
    PODData: [],
};
const PODDataReducer = {
    "Custom/PODData/BeginLoadPODData": (draft: Draft<PODDataState>) => {
        draft.isLoading = true;
    },
    "Custom/PODData/CompletedLoadPODData": (
        draft: Draft<PODDataState>,
        action: {
            result: PODDataModel;
        },
    ) => {
        draft.PODData = action.result;
        draft.isLoading = false;
    },
};

export default createTypedReducerWithImmer(initialState, PODDataReducer);
